import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import urlParse from 'url-parse';
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

var bridge = {
  default: commonjsGlobal,
  // for typescript
  call: function call(method, args, cb) {
    var ret = '';

    if (typeof args == 'function') {
      cb = args;
      args = {};
    }

    var arg = {
      data: args === undefined ? null : args
    };

    if (typeof cb == 'function') {
      var cbName = 'dscb' + window.dscb++;
      window[cbName] = cb;
      arg['_dscbstub'] = cbName;
    }

    arg = JSON.stringify(arg); //if in webview that dsBridge provided, call!

    if (window._dsbridge) {
      ret = _dsbridge.call(method, arg);
    } else if (window._dswk || navigator.userAgent.indexOf("_dsbridge") != -1) {
      ret = prompt("_dsbridge=" + method, arg);
    }

    return JSON.parse(ret || '{}').data;
  },
  register: function register(name, fun, asyn) {
    var q = asyn ? window._dsaf : window._dsf;

    if (!window._dsInit) {
      window._dsInit = true; //notify native that js apis register successfully on next event loop

      setTimeout(function () {
        bridge.call("_dsb.dsinit");
      }, 0);
    }

    if (_typeof(fun) == "object") {
      q._obs[name] = fun;
    } else {
      q[name] = fun;
    }
  },
  registerAsyn: function registerAsyn(name, fun) {
    this.register(name, fun, true);
  },
  hasNativeMethod: function hasNativeMethod(name, type) {
    return this.call("_dsb.hasNativeMethod", {
      name: name,
      type: type || "all"
    });
  },
  disableJavascriptDialogBlock: function disableJavascriptDialogBlock(disable) {
    this.call("_dsb.disableJavascriptDialogBlock", {
      disable: disable !== false
    });
  }
};
!function () {
  if (window._dsf) {
    return;
  }

  var ob = {
    _dsf: {
      _obs: {}
    },
    _dsaf: {
      _obs: {}
    },
    dscb: 0,
    dsBridge: bridge,
    close: function close() {
      bridge.call("_dsb.closePage");
    },
    _handleMessageFromNative: function _handleMessageFromNative(info) {
      var arg = JSON.parse(info.data);
      var ret = {
        id: info.callbackId,
        complete: true
      };
      var f = this._dsf[info.method];
      var af = this._dsaf[info.method];

      var callSyn = function callSyn(f, ob) {
        ret.data = f.apply(ob, arg);
        bridge.call("_dsb.returnValue", ret);
      };

      var callAsyn = function callAsyn(f, ob) {
        arg.push(function (data, complete) {
          ret.data = data;
          ret.complete = complete !== false;
          bridge.call("_dsb.returnValue", ret);
        });
        f.apply(ob, arg);
      };

      if (f) {
        callSyn(f, this._dsf);
      } else if (af) {
        callAsyn(af, this._dsaf);
      } else {
        //with namespace
        var name = info.method.split('.');

        if (name.length < 2) {
          return;
        }

        var method = name.pop();
        var namespace = name.join('.');
        var obs = this._dsf._obs;
        var ob = obs[namespace] || {};
        var m = ob[method];

        if (m && typeof m == "function") {
          callSyn(m, ob);
          return;
        }

        obs = this._dsaf._obs;
        ob = obs[namespace] || {};
        m = ob[method];

        if (m && typeof m == "function") {
          callAsyn(m, ob);
          return;
        }
      }
    }
  };

  for (var attr in ob) {
    window[attr] = ob[attr];
  }

  bridge.register("_hasJavascriptMethod", function (method, tag) {
    var name = method.split('.');

    if (name.length < 2) {
      return !!(_dsf[name] || _dsaf[name]);
    } else {
      // with namespace
      var method = name.pop();
      var namespace = name.join('.');
      var ob = _dsf._obs[namespace] || _dsaf._obs[namespace];
      return ob && !!ob[method];
    }
  });
}();
var dsbridge = bridge; // 是否为app内

var isApp = function isApp() {
  return window && window.navigator.userAgent.includes('longbridge');
}; // 需要同步调用的dsbridge


var CALL_LIST = ['lbCheckAppUpdate', 'lbOpenWebview', 'lbGetNativePage', 'lbCheckSupportPath', 'lbGetMarkets', 'lbGetUserMarkets', 'lbOpenPDF', 'lbEventRecord', 'lbBIEventRecord', 'lbGetSupportList']; // 判断客服端页面是否支持

var SUPPORT_LIST = ['customerService', 'openAccountComplete', 'lb://page/mine/open_account', 'lb://page/open_account/status', 'lb://page/mine/id_card_auth', 'lb://page/fund/revenues_details', 'lb://page/fund/transactions_history', 'lb://page/mine/sip/cka', 'lb://page/mine/deposit', 'lb://page/fund/deal', 'lb://page/stock/detail', 'lb://page/ut/dividend/records', 'lb://page/login/guide', 'lb://page/dialog/alert', 'lb://page/ipo/deal', 'lb://page/ipo/record/list', 'lb://page/ipo/record/detail', 'lb://page/dialog/event', 'lb://page/fund/list', 'lb://page/login', 'lb://page/mine/deposit', 'lb://page/ipo/list', 'lb://page/mine/transfer', 'lb://page/mine/activity']; // 需要用户交互的jsbridge

var OPERATE_LIST = ['lbCheckTradeToken', 'lbAlert', 'lbGetPhotos', 'lbGetImage', 'lbGetLocation', 'lbGetSignature', 'lbScanCode']; // 需要判断是否以 https 开头的 jsbridge

var HTTPS_LIST = ['lbOpenWebview', 'lbSaveImage', 'lbOpenPDF', 'lbGetNativePage']; // 分享链接需要去掉的参数

var BLACK_PARAMS_LIST = ['lblang', 'lbapp', 'lbtheme', 'need_login']; // 正常bridge方法返回为空会报错，在这个名单里的可以忽略这个报错

var IGNORE_EMPTY_LIST = ['lbGetNativePage', 'lbRiskResult', 'lbGetSupportList'];

var hasNativePath = function hasNativePath(params) {
  if (SUPPORT_LIST.includes(params.key)) {
    return {
      status: true
    };
  }

  if (!dsbridge.hasNativeMethod('lbCheckSupportPath')) {
    return {
      status: false
    };
  }

  var resp = dsbridge.call('lbCheckSupportPath', params);

  try {
    return JSON.parse(resp);
  } catch (e) {
    return {
      status: false
    };
  }
};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */


function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }

  return result;
}

var _arrayMap = arrayMap;
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */

function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */

function eq(value, other) {
  return value === other || value !== value && other !== other;
}

var eq_1 = eq;
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */

function assocIndexOf(array, key) {
  var length = array.length;

  while (length--) {
    if (eq_1(array[length][0], key)) {
      return length;
    }
  }

  return -1;
}

var _assocIndexOf = assocIndexOf;
/** Used for built-in method references. */

var arrayProto = Array.prototype;
/** Built-in value references. */

var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function listCacheDelete(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }

  var lastIndex = data.length - 1;

  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }

  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete;
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function listCacheGet(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet;
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function listCacheHas(key) {
  return _assocIndexOf(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas;
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */

function listCacheSet(key, value) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }

  return this;
}

var _listCacheSet = listCacheSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `ListCache`.


ListCache.prototype.clear = _listCacheClear;
ListCache.prototype['delete'] = _listCacheDelete;
ListCache.prototype.get = _listCacheGet;
ListCache.prototype.has = _listCacheHas;
ListCache.prototype.set = _listCacheSet;
var _ListCache = ListCache;
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */

function stackClear() {
  this.__data__ = new _ListCache();
  this.size = 0;
}

var _stackClear = stackClear;
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);
  this.size = data.size;
  return result;
}

var _stackDelete = stackDelete;
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function stackGet(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet;
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function stackHas(key) {
  return this.__data__.has(key);
}

var _stackHas = stackHas;
/** Detect free variable `global` from Node.js. */

var freeGlobal = _typeof(commonjsGlobal) == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal;
/** Detect free variable `self`. */

var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof(self)) == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */

var root = _freeGlobal || freeSelf || Function('return this')();
var _root = root;
/** Built-in value references. */

var _Symbol2 = _root.Symbol;
var _Symbol = _Symbol2;
/** Used for built-in method references. */

var objectProto = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var nativeObjectToString = objectProto.toString;
/** Built-in value references. */

var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */

function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);

  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }

  return result;
}

var _getRawTag = getRawTag;
/** Used for built-in method references. */

var objectProto$1 = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var nativeObjectToString$1 = objectProto$1.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */

function objectToString(value) {
  return nativeObjectToString$1.call(value);
}

var _objectToString = objectToString;
/** `Object#toString` result references. */

var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';
/** Built-in value references. */

var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */

function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }

  return symToStringTag$1 && symToStringTag$1 in Object(value) ? _getRawTag(value) : _objectToString(value);
}

var _baseGetTag = baseGetTag;
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */

function isObject(value) {
  var type = _typeof(value);

  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject;
/** `Object#toString` result references. */

var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */

function isFunction(value) {
  if (!isObject_1(value)) {
    return false;
  } // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.


  var tag = _baseGetTag(value);

  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction;
/** Used to detect overreaching core-js shims. */

var coreJsData = _root['__core-js_shared__'];
var _coreJsData = coreJsData;
/** Used to detect methods masquerading as native. */

var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */


function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

var _isMasked = isMasked;
/** Used for built-in method references. */

var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */

function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}

    try {
      return func + '';
    } catch (e$1) {}
  }

  return '';
}

var _toSource = toSource;
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */

var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */

var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */

var funcProto$1 = Function.prototype,
    objectProto$2 = Object.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString$1 = funcProto$1.toString;
/** Used to check objects for own properties. */

var hasOwnProperty$1 = objectProto$2.hasOwnProperty;
/** Used to detect if a method is native. */

var reIsNative = RegExp('^' + funcToString$1.call(hasOwnProperty$1).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */

function baseIsNative(value) {
  if (!isObject_1(value) || _isMasked(value)) {
    return false;
  }

  var pattern = isFunction_1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(_toSource(value));
}

var _baseIsNative = baseIsNative;
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */

function getValue(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue;
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */

function getNative(object, key) {
  var value = _getValue(object, key);

  return _baseIsNative(value) ? value : undefined;
}

var _getNative = getNative;
/* Built-in method references that are verified to be native. */

var Map = _getNative(_root, 'Map');

var _Map = Map;
/* Built-in method references that are verified to be native. */

var nativeCreate = _getNative(Object, 'create');

var _nativeCreate = nativeCreate;
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */

function hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
  this.size = 0;
}

var _hashClear = hashClear;
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete;
/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */

var objectProto$3 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$2 = objectProto$3.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function hashGet(key) {
  var data = this.__data__;

  if (_nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }

  return hasOwnProperty$2.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet;
/** Used for built-in method references. */

var objectProto$4 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$3 = objectProto$4.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function hashHas(key) {
  var data = this.__data__;
  return _nativeCreate ? data[key] !== undefined : hasOwnProperty$3.call(data, key);
}

var _hashHas = hashHas;
/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */

function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = _nativeCreate && value === undefined ? HASH_UNDEFINED$1 : value;
  return this;
}

var _hashSet = hashSet;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `Hash`.


Hash.prototype.clear = _hashClear;
Hash.prototype['delete'] = _hashDelete;
Hash.prototype.get = _hashGet;
Hash.prototype.has = _hashHas;
Hash.prototype.set = _hashSet;
var _Hash = Hash;
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */

function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash(),
    'map': new (_Map || _ListCache)(),
    'string': new _Hash()
  };
}

var _mapCacheClear = mapCacheClear;
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */

function isKeyable(value) {
  var type = _typeof(value);

  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

var _isKeyable = isKeyable;
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */

function getMapData(map, key) {
  var data = map.__data__;
  return _isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

var _getMapData = getMapData;
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function mapCacheDelete(key) {
  var result = _getMapData(this, key)['delete'](key);

  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete;
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function mapCacheGet(key) {
  return _getMapData(this, key).get(key);
}

var _mapCacheGet = mapCacheGet;
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function mapCacheHas(key) {
  return _getMapData(this, key).has(key);
}

var _mapCacheHas = mapCacheHas;
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */

function mapCacheSet(key, value) {
  var data = _getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `MapCache`.


MapCache.prototype.clear = _mapCacheClear;
MapCache.prototype['delete'] = _mapCacheDelete;
MapCache.prototype.get = _mapCacheGet;
MapCache.prototype.has = _mapCacheHas;
MapCache.prototype.set = _mapCacheSet;
var _MapCache = MapCache;
/** Used as the size to enable large array optimizations. */

var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */

function stackSet(key, value) {
  var data = this.__data__;

  if (data instanceof _ListCache) {
    var pairs = data.__data__;

    if (!_Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }

    data = this.__data__ = new _MapCache(pairs);
  }

  data.set(key, value);
  this.size = data.size;
  return this;
}

var _stackSet = stackSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function Stack(entries) {
  var data = this.__data__ = new _ListCache(entries);
  this.size = data.size;
} // Add methods to `Stack`.


Stack.prototype.clear = _stackClear;
Stack.prototype['delete'] = _stackDelete;
Stack.prototype.get = _stackGet;
Stack.prototype.has = _stackHas;
Stack.prototype.set = _stackSet;
var _Stack = Stack;
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */

function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }

  return array;
}

var _arrayEach = arrayEach;

var defineProperty = function () {
  try {
    var func = _getNative(Object, 'defineProperty');

    func({}, '', {});
    return func;
  } catch (e) {}
}();

var _defineProperty = defineProperty;
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */

function baseAssignValue(object, key, value) {
  if (key == '__proto__' && _defineProperty) {
    _defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

var _baseAssignValue = baseAssignValue;
/** Used for built-in method references. */

var objectProto$5 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$4 = objectProto$5.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */

function assignValue(object, key, value) {
  var objValue = object[key];

  if (!(hasOwnProperty$4.call(object, key) && eq_1(objValue, value)) || value === undefined && !(key in object)) {
    _baseAssignValue(object, key, value);
  }
}

var _assignValue = assignValue;
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */

function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});
  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];
    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }

    if (isNew) {
      _baseAssignValue(object, key, newValue);
    } else {
      _assignValue(object, key, newValue);
    }
  }

  return object;
}

var _copyObject = copyObject;
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */

function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }

  return result;
}

var _baseTimes = baseTimes;
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */

function isObjectLike(value) {
  return value != null && _typeof(value) == 'object';
}

var isObjectLike_1 = isObjectLike;
/** `Object#toString` result references. */

var argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */

function baseIsArguments(value) {
  return isObjectLike_1(value) && _baseGetTag(value) == argsTag;
}

var _baseIsArguments = baseIsArguments;
/** Used for built-in method references. */

var objectProto$6 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$5 = objectProto$6.hasOwnProperty;
/** Built-in value references. */

var propertyIsEnumerable = objectProto$6.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */

var isArguments = _baseIsArguments(function () {
  return arguments;
}()) ? _baseIsArguments : function (value) {
  return isObjectLike_1(value) && hasOwnProperty$5.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
var isArguments_1 = isArguments;
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */

var isArray = Array.isArray;
var isArray_1 = isArray;
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */

function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;
var isBuffer_1 = createCommonjsModule(function (module, exports) {
  /** Detect free variable `exports`. */
  var freeExports = exports && !exports.nodeType && exports;
  /** Detect free variable `module`. */

  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
  /** Detect the popular CommonJS extension `module.exports`. */

  var moduleExports = freeModule && freeModule.exports === freeExports;
  /** Built-in value references. */

  var Buffer = moduleExports ? _root.Buffer : undefined;
  /* Built-in method references for those with the same name as other `lodash` methods. */

  var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
  /**
   * Checks if `value` is a buffer.
   *
   * @static
   * @memberOf _
   * @since 4.3.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
   * @example
   *
   * _.isBuffer(new Buffer(2));
   * // => true
   *
   * _.isBuffer(new Uint8Array(2));
   * // => false
   */

  var isBuffer = nativeIsBuffer || stubFalse_1;
  module.exports = isBuffer;
});
/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */

var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */

function isIndex(value, length) {
  var type = _typeof(value);

  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

var _isIndex = isIndex;
/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER$1 = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */

function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
}

var isLength_1 = isLength;
/** `Object#toString` result references. */

var argsTag$1 = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag$1 = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */

var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag$1] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */

function baseIsTypedArray(value) {
  return isObjectLike_1(value) && isLength_1(value.length) && !!typedArrayTags[_baseGetTag(value)];
}

var _baseIsTypedArray = baseIsTypedArray;
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */

function baseUnary(func) {
  return function (value) {
    return func(value);
  };
}

var _baseUnary = baseUnary;

var _nodeUtil = createCommonjsModule(function (module, exports) {
  /** Detect free variable `exports`. */
  var freeExports = exports && !exports.nodeType && exports;
  /** Detect free variable `module`. */

  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
  /** Detect the popular CommonJS extension `module.exports`. */

  var moduleExports = freeModule && freeModule.exports === freeExports;
  /** Detect free variable `process` from Node.js. */

  var freeProcess = moduleExports && _freeGlobal.process;
  /** Used to access faster Node.js helpers. */

  var nodeUtil = function () {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      } // Legacy `process.binding('util')` for Node.js < 10.


      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }();

  module.exports = nodeUtil;
});
/* Node.js helper references. */


var nodeIsTypedArray = _nodeUtil && _nodeUtil.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */

var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;
var isTypedArray_1 = isTypedArray;
/** Used for built-in method references. */

var objectProto$7 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$6 = objectProto$7.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */

function arrayLikeKeys(value, inherited) {
  var isArr = isArray_1(value),
      isArg = !isArr && isArguments_1(value),
      isBuff = !isArr && !isArg && isBuffer_1(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray_1(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? _baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$6.call(value, key)) && !(skipIndexes && ( // Safari 9 has enumerable `arguments.length` in strict mode.
    key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    _isIndex(key, length)))) {
      result.push(key);
    }
  }

  return result;
}

var _arrayLikeKeys = arrayLikeKeys;
/** Used for built-in method references. */

var objectProto$8 = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */

function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$8;
  return value === proto;
}

var _isPrototype = isPrototype;
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */

function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeKeys = _overArg(Object.keys, Object);

var _nativeKeys = nativeKeys;
/** Used for built-in method references. */

var objectProto$9 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$7 = objectProto$9.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function baseKeys(object) {
  if (!_isPrototype(object)) {
    return _nativeKeys(object);
  }

  var result = [];

  for (var key in Object(object)) {
    if (hasOwnProperty$7.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }

  return result;
}

var _baseKeys = baseKeys;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */

function isArrayLike(value) {
  return value != null && isLength_1(value.length) && !isFunction_1(value);
}

var isArrayLike_1 = isArrayLike;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */

function keys(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object) : _baseKeys(object);
}

var keys_1 = keys;
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */

function baseAssign(object, source) {
  return object && _copyObject(source, keys_1(source), object);
}

var _baseAssign = baseAssign;
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function nativeKeysIn(object) {
  var result = [];

  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }

  return result;
}

var _nativeKeysIn = nativeKeysIn;
/** Used for built-in method references. */

var objectProto$a = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$8 = objectProto$a.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function baseKeysIn(object) {
  if (!isObject_1(object)) {
    return _nativeKeysIn(object);
  }

  var isProto = _isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$8.call(object, key)))) {
      result.push(key);
    }
  }

  return result;
}

var _baseKeysIn = baseKeysIn;
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */

function keysIn(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object, true) : _baseKeysIn(object);
}

var keysIn_1 = keysIn;
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */

function baseAssignIn(object, source) {
  return object && _copyObject(source, keysIn_1(source), object);
}

var _baseAssignIn = baseAssignIn;

var _cloneBuffer = createCommonjsModule(function (module, exports) {
  /** Detect free variable `exports`. */
  var freeExports = exports && !exports.nodeType && exports;
  /** Detect free variable `module`. */

  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
  /** Detect the popular CommonJS extension `module.exports`. */

  var moduleExports = freeModule && freeModule.exports === freeExports;
  /** Built-in value references. */

  var Buffer = moduleExports ? _root.Buffer : undefined,
      allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
  /**
   * Creates a clone of  `buffer`.
   *
   * @private
   * @param {Buffer} buffer The buffer to clone.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Buffer} Returns the cloned buffer.
   */

  function cloneBuffer(buffer, isDeep) {
    if (isDeep) {
      return buffer.slice();
    }

    var length = buffer.length,
        result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
  }

  module.exports = cloneBuffer;
});
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */


function copyArray(source, array) {
  var index = -1,
      length = source.length;
  array || (array = Array(length));

  while (++index < length) {
    array[index] = source[index];
  }

  return array;
}

var _copyArray = copyArray;
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */

function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];

    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }

  return result;
}

var _arrayFilter = arrayFilter;
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */

function stubArray() {
  return [];
}

var stubArray_1 = stubArray;
/** Used for built-in method references. */

var objectProto$b = Object.prototype;
/** Built-in value references. */

var propertyIsEnumerable$1 = objectProto$b.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */

var getSymbols = !nativeGetSymbols ? stubArray_1 : function (object) {
  if (object == null) {
    return [];
  }

  object = Object(object);
  return _arrayFilter(nativeGetSymbols(object), function (symbol) {
    return propertyIsEnumerable$1.call(object, symbol);
  });
};
var _getSymbols = getSymbols;
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */

function copySymbols(source, object) {
  return _copyObject(source, _getSymbols(source), object);
}

var _copySymbols = copySymbols;
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */

function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }

  return array;
}

var _arrayPush = arrayPush;
/** Built-in value references. */

var getPrototype = _overArg(Object.getPrototypeOf, Object);

var _getPrototype = getPrototype;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeGetSymbols$1 = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */

var getSymbolsIn = !nativeGetSymbols$1 ? stubArray_1 : function (object) {
  var result = [];

  while (object) {
    _arrayPush(result, _getSymbols(object));

    object = _getPrototype(object);
  }

  return result;
};
var _getSymbolsIn = getSymbolsIn;
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */

function copySymbolsIn(source, object) {
  return _copyObject(source, _getSymbolsIn(source), object);
}

var _copySymbolsIn = copySymbolsIn;
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */

function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray_1(object) ? result : _arrayPush(result, symbolsFunc(object));
}

var _baseGetAllKeys = baseGetAllKeys;
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */

function getAllKeys(object) {
  return _baseGetAllKeys(object, keys_1, _getSymbols);
}

var _getAllKeys = getAllKeys;
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */

function getAllKeysIn(object) {
  return _baseGetAllKeys(object, keysIn_1, _getSymbolsIn);
}

var _getAllKeysIn = getAllKeysIn;
/* Built-in method references that are verified to be native. */

var DataView = _getNative(_root, 'DataView');

var _DataView = DataView;
/* Built-in method references that are verified to be native. */

var Promise$1 = _getNative(_root, 'Promise');

var _Promise = Promise$1;
/* Built-in method references that are verified to be native. */

var Set = _getNative(_root, 'Set');

var _Set = Set;
/* Built-in method references that are verified to be native. */

var WeakMap = _getNative(_root, 'WeakMap');

var _WeakMap = WeakMap;
/** `Object#toString` result references. */

var mapTag$1 = '[object Map]',
    objectTag$1 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag$1 = '[object Set]',
    weakMapTag$1 = '[object WeakMap]';
var dataViewTag$1 = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */

var dataViewCtorString = _toSource(_DataView),
    mapCtorString = _toSource(_Map),
    promiseCtorString = _toSource(_Promise),
    setCtorString = _toSource(_Set),
    weakMapCtorString = _toSource(_WeakMap);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */


var getTag = _baseGetTag; // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.

if (_DataView && getTag(new _DataView(new ArrayBuffer(1))) != dataViewTag$1 || _Map && getTag(new _Map()) != mapTag$1 || _Promise && getTag(_Promise.resolve()) != promiseTag || _Set && getTag(new _Set()) != setTag$1 || _WeakMap && getTag(new _WeakMap()) != weakMapTag$1) {
  getTag = function getTag(value) {
    var result = _baseGetTag(value),
        Ctor = result == objectTag$1 ? value.constructor : undefined,
        ctorString = Ctor ? _toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag$1;

        case mapCtorString:
          return mapTag$1;

        case promiseCtorString:
          return promiseTag;

        case setCtorString:
          return setTag$1;

        case weakMapCtorString:
          return weakMapTag$1;
      }
    }

    return result;
  };
}

var _getTag = getTag;
/** Used for built-in method references. */

var objectProto$c = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$9 = objectProto$c.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */

function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length); // Add properties assigned by `RegExp#exec`.

  if (length && typeof array[0] == 'string' && hasOwnProperty$9.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }

  return result;
}

var _initCloneArray = initCloneArray;
/** Built-in value references. */

var Uint8Array = _root.Uint8Array;
var _Uint8Array = Uint8Array;
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */

function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new _Uint8Array(result).set(new _Uint8Array(arrayBuffer));
  return result;
}

var _cloneArrayBuffer = cloneArrayBuffer;
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */

function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? _cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

var _cloneDataView = cloneDataView;
/** Used to match `RegExp` flags from their coerced string values. */

var reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */

function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

var _cloneRegExp = cloneRegExp;
/** Used to convert symbols to primitives and strings. */

var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */

function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

var _cloneSymbol = cloneSymbol;
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */

function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? _cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

var _cloneTypedArray = cloneTypedArray;
/** `Object#toString` result references. */

var boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    mapTag$2 = '[object Map]',
    numberTag$1 = '[object Number]',
    regexpTag$1 = '[object RegExp]',
    setTag$2 = '[object Set]',
    stringTag$1 = '[object String]',
    symbolTag = '[object Symbol]';
var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$2 = '[object DataView]',
    float32Tag$1 = '[object Float32Array]',
    float64Tag$1 = '[object Float64Array]',
    int8Tag$1 = '[object Int8Array]',
    int16Tag$1 = '[object Int16Array]',
    int32Tag$1 = '[object Int32Array]',
    uint8Tag$1 = '[object Uint8Array]',
    uint8ClampedTag$1 = '[object Uint8ClampedArray]',
    uint16Tag$1 = '[object Uint16Array]',
    uint32Tag$1 = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */

function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;

  switch (tag) {
    case arrayBufferTag$1:
      return _cloneArrayBuffer(object);

    case boolTag$1:
    case dateTag$1:
      return new Ctor(+object);

    case dataViewTag$2:
      return _cloneDataView(object, isDeep);

    case float32Tag$1:
    case float64Tag$1:
    case int8Tag$1:
    case int16Tag$1:
    case int32Tag$1:
    case uint8Tag$1:
    case uint8ClampedTag$1:
    case uint16Tag$1:
    case uint32Tag$1:
      return _cloneTypedArray(object, isDeep);

    case mapTag$2:
      return new Ctor();

    case numberTag$1:
    case stringTag$1:
      return new Ctor(object);

    case regexpTag$1:
      return _cloneRegExp(object);

    case setTag$2:
      return new Ctor();

    case symbolTag:
      return _cloneSymbol(object);
  }
}

var _initCloneByTag = initCloneByTag;
/** Built-in value references. */

var objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */

var baseCreate = function () {
  function object() {}

  return function (proto) {
    if (!isObject_1(proto)) {
      return {};
    }

    if (objectCreate) {
      return objectCreate(proto);
    }

    object.prototype = proto;
    var result = new object();
    object.prototype = undefined;
    return result;
  };
}();

var _baseCreate = baseCreate;
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */

function initCloneObject(object) {
  return typeof object.constructor == 'function' && !_isPrototype(object) ? _baseCreate(_getPrototype(object)) : {};
}

var _initCloneObject = initCloneObject;
/** `Object#toString` result references. */

var mapTag$3 = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */

function baseIsMap(value) {
  return isObjectLike_1(value) && _getTag(value) == mapTag$3;
}

var _baseIsMap = baseIsMap;
/* Node.js helper references. */

var nodeIsMap = _nodeUtil && _nodeUtil.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */

var isMap = nodeIsMap ? _baseUnary(nodeIsMap) : _baseIsMap;
var isMap_1 = isMap;
/** `Object#toString` result references. */

var setTag$3 = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */

function baseIsSet(value) {
  return isObjectLike_1(value) && _getTag(value) == setTag$3;
}

var _baseIsSet = baseIsSet;
/* Node.js helper references. */

var nodeIsSet = _nodeUtil && _nodeUtil.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */

var isSet = nodeIsSet ? _baseUnary(nodeIsSet) : _baseIsSet;
var isSet_1 = isSet;
/** Used to compose bitmasks for cloning. */

var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */

var argsTag$2 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    boolTag$2 = '[object Boolean]',
    dateTag$2 = '[object Date]',
    errorTag$1 = '[object Error]',
    funcTag$2 = '[object Function]',
    genTag$1 = '[object GeneratorFunction]',
    mapTag$4 = '[object Map]',
    numberTag$2 = '[object Number]',
    objectTag$2 = '[object Object]',
    regexpTag$2 = '[object RegExp]',
    setTag$4 = '[object Set]',
    stringTag$2 = '[object String]',
    symbolTag$1 = '[object Symbol]',
    weakMapTag$2 = '[object WeakMap]';
var arrayBufferTag$2 = '[object ArrayBuffer]',
    dataViewTag$3 = '[object DataView]',
    float32Tag$2 = '[object Float32Array]',
    float64Tag$2 = '[object Float64Array]',
    int8Tag$2 = '[object Int8Array]',
    int16Tag$2 = '[object Int16Array]',
    int32Tag$2 = '[object Int32Array]',
    uint8Tag$2 = '[object Uint8Array]',
    uint8ClampedTag$2 = '[object Uint8ClampedArray]',
    uint16Tag$2 = '[object Uint16Array]',
    uint32Tag$2 = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */

var cloneableTags = {};
cloneableTags[argsTag$2] = cloneableTags[arrayTag$1] = cloneableTags[arrayBufferTag$2] = cloneableTags[dataViewTag$3] = cloneableTags[boolTag$2] = cloneableTags[dateTag$2] = cloneableTags[float32Tag$2] = cloneableTags[float64Tag$2] = cloneableTags[int8Tag$2] = cloneableTags[int16Tag$2] = cloneableTags[int32Tag$2] = cloneableTags[mapTag$4] = cloneableTags[numberTag$2] = cloneableTags[objectTag$2] = cloneableTags[regexpTag$2] = cloneableTags[setTag$4] = cloneableTags[stringTag$2] = cloneableTags[symbolTag$1] = cloneableTags[uint8Tag$2] = cloneableTags[uint8ClampedTag$2] = cloneableTags[uint16Tag$2] = cloneableTags[uint32Tag$2] = true;
cloneableTags[errorTag$1] = cloneableTags[funcTag$2] = cloneableTags[weakMapTag$2] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */

function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }

  if (result !== undefined) {
    return result;
  }

  if (!isObject_1(value)) {
    return value;
  }

  var isArr = isArray_1(value);

  if (isArr) {
    result = _initCloneArray(value);

    if (!isDeep) {
      return _copyArray(value, result);
    }
  } else {
    var tag = _getTag(value),
        isFunc = tag == funcTag$2 || tag == genTag$1;

    if (isBuffer_1(value)) {
      return _cloneBuffer(value, isDeep);
    }

    if (tag == objectTag$2 || tag == argsTag$2 || isFunc && !object) {
      result = isFlat || isFunc ? {} : _initCloneObject(value);

      if (!isDeep) {
        return isFlat ? _copySymbolsIn(value, _baseAssignIn(result, value)) : _copySymbols(value, _baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }

      result = _initCloneByTag(value, tag, isDeep);
    }
  } // Check for circular references and return its corresponding clone.


  stack || (stack = new _Stack());
  var stacked = stack.get(value);

  if (stacked) {
    return stacked;
  }

  stack.set(value, result);

  if (isSet_1(value)) {
    value.forEach(function (subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap_1(value)) {
    value.forEach(function (subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull ? isFlat ? _getAllKeysIn : _getAllKeys : isFlat ? keysIn_1 : keys_1;
  var props = isArr ? undefined : keysFunc(value);

  _arrayEach(props || value, function (subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    } // Recursively populate clone (susceptible to call stack limits).


    _assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });

  return result;
}

var _baseClone = baseClone;
/** `Object#toString` result references. */

var symbolTag$2 = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */

function isSymbol(value) {
  return _typeof(value) == 'symbol' || isObjectLike_1(value) && _baseGetTag(value) == symbolTag$2;
}

var isSymbol_1 = isSymbol;
/** Used to match property names within property paths. */

var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */

function isKey(value, object) {
  if (isArray_1(value)) {
    return false;
  }

  var type = _typeof(value);

  if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol_1(value)) {
    return true;
  }

  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}

var _isKey = isKey;
/** Error message constants. */

var FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */

function memoize(func, resolver) {
  if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }

  var memoized = function memoized() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }

    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };

  memoized.cache = new (memoize.Cache || _MapCache)();
  return memoized;
} // Expose `MapCache`.


memoize.Cache = _MapCache;
var memoize_1 = memoize;
/** Used as the maximum memoize cache size. */

var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */

function memoizeCapped(func) {
  var result = memoize_1(func, function (key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }

    return key;
  });
  var cache = result.cache;
  return result;
}

var _memoizeCapped = memoizeCapped;
/** Used to match property names within property paths. */

var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */

var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */

var stringToPath = _memoizeCapped(function (string) {
  var result = [];

  if (string.charCodeAt(0) === 46
  /* . */
  ) {
      result.push('');
    }

  string.replace(rePropName, function (match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
  });
  return result;
});

var _stringToPath = stringToPath;
/** Used as references for various `Number` constants. */

var INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */

var symbolProto$1 = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = symbolProto$1 ? symbolProto$1.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */

function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }

  if (isArray_1(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return _arrayMap(value, baseToString) + '';
  }

  if (isSymbol_1(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }

  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

var _baseToString = baseToString;
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */

function toString(value) {
  return value == null ? '' : _baseToString(value);
}

var toString_1 = toString;
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */

function castPath(value, object) {
  if (isArray_1(value)) {
    return value;
  }

  return _isKey(value, object) ? [value] : _stringToPath(toString_1(value));
}

var _castPath = castPath;
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */

function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

var last_1 = last;
/** Used as references for various `Number` constants. */

var INFINITY$1 = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */

function toKey(value) {
  if (typeof value == 'string' || isSymbol_1(value)) {
    return value;
  }

  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$1 ? '-0' : result;
}

var _toKey = toKey;
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */

function baseGet(object, path) {
  path = _castPath(path, object);
  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[_toKey(path[index++])];
  }

  return index && index == length ? object : undefined;
}

var _baseGet = baseGet;
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */

function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : length + start;
  }

  end = end > length ? length : end;

  if (end < 0) {
    end += length;
  }

  length = start > end ? 0 : end - start >>> 0;
  start >>>= 0;
  var result = Array(length);

  while (++index < length) {
    result[index] = array[index + start];
  }

  return result;
}

var _baseSlice = baseSlice;
/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */

function parent(object, path) {
  return path.length < 2 ? object : _baseGet(object, _baseSlice(path, 0, -1));
}

var _parent = parent;
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */

function baseUnset(object, path) {
  path = _castPath(path, object);
  object = _parent(object, path);
  return object == null || delete object[_toKey(last_1(path))];
}

var _baseUnset = baseUnset;
/** `Object#toString` result references. */

var objectTag$3 = '[object Object]';
/** Used for built-in method references. */

var funcProto$2 = Function.prototype,
    objectProto$d = Object.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString$2 = funcProto$2.toString;
/** Used to check objects for own properties. */

var hasOwnProperty$a = objectProto$d.hasOwnProperty;
/** Used to infer the `Object` constructor. */

var objectCtorString = funcToString$2.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */

function isPlainObject(value) {
  if (!isObjectLike_1(value) || _baseGetTag(value) != objectTag$3) {
    return false;
  }

  var proto = _getPrototype(value);

  if (proto === null) {
    return true;
  }

  var Ctor = hasOwnProperty$a.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString$2.call(Ctor) == objectCtorString;
}

var isPlainObject_1 = isPlainObject;
/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */

function customOmitClone(value) {
  return isPlainObject_1(value) ? undefined : value;
}

var _customOmitClone = customOmitClone;
/** Built-in value references. */

var spreadableSymbol = _Symbol ? _Symbol.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */

function isFlattenable(value) {
  return isArray_1(value) || isArguments_1(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}

var _isFlattenable = isFlattenable;
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */

function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;
  predicate || (predicate = _isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];

    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        _arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }

  return result;
}

var _baseFlatten = baseFlatten;
/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */

function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? _baseFlatten(array, 1) : [];
}

var flatten_1 = flatten;
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */

function apply(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);

    case 1:
      return func.call(thisArg, args[0]);

    case 2:
      return func.call(thisArg, args[0], args[1]);

    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }

  return func.apply(thisArg, args);
}

var _apply = apply;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */

function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? func.length - 1 : start, 0);
  return function () {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }

    index = -1;
    var otherArgs = Array(start + 1);

    while (++index < start) {
      otherArgs[index] = args[index];
    }

    otherArgs[start] = transform(array);
    return _apply(func, this, otherArgs);
  };
}

var _overRest = overRest;
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */

function constant(value) {
  return function () {
    return value;
  };
}

var constant_1 = constant;
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */

function identity(value) {
  return value;
}

var identity_1 = identity;
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */

var baseSetToString = !_defineProperty ? identity_1 : function (func, string) {
  return _defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant_1(string),
    'writable': true
  });
};
var _baseSetToString = baseSetToString;
/** Used to detect hot functions by number of calls within a span of milliseconds. */

var HOT_COUNT = 800,
    HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */

function shortOut(func) {
  var count = 0,
      lastCalled = 0;
  return function () {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);
    lastCalled = stamp;

    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }

    return func.apply(undefined, arguments);
  };
}

var _shortOut = shortOut;
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */

var setToString = _shortOut(_baseSetToString);

var _setToString = setToString;
/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */

function flatRest(func) {
  return _setToString(_overRest(func, undefined, flatten_1), func + '');
}

var _flatRest = flatRest;
/** Used to compose bitmasks for cloning. */

var CLONE_DEEP_FLAG$1 = 1,
    CLONE_FLAT_FLAG$1 = 2,
    CLONE_SYMBOLS_FLAG$1 = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */

var omit = _flatRest(function (object, paths) {
  var result = {};

  if (object == null) {
    return result;
  }

  var isDeep = false;
  paths = _arrayMap(paths, function (path) {
    path = _castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });

  _copyObject(object, _getAllKeysIn(object), result);

  if (isDeep) {
    result = _baseClone(result, CLONE_DEEP_FLAG$1 | CLONE_FLAT_FLAG$1 | CLONE_SYMBOLS_FLAG$1, _customOmitClone);
  }

  var length = paths.length;

  while (length--) {
    _baseUnset(result, paths[length]);
  }

  return result;
});

var omit_1 = omit;

var deleteParams = function deleteParams(url) {
  var parseObj = urlParse(url, true);
  var query = parseObj.query;
  var origin = parseObj.origin;
  var pathname = parseObj.pathname;
  var newQueryObject = omit_1(query, BLACK_PARAMS_LIST);
  var newQuery = urlParse.qs.stringify(newQueryObject, true);
  return "" + origin + pathname + newQuery;
}; // 获取用户 token


var lbGetToken = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var resp;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return dsbridgeSync('lbGetToken');

          case 2:
            resp = _context.sent;

            if (!resp.status) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return", resp.data && resp.data.token);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function lbGetToken() {
    return _ref.apply(this, arguments);
  };
}();
/**
 * @description dsbridge 方法封装 (如果需要捕获错误并上报，使用前需要dsbridgeSync.CaptureError = Vue.$Sentry.lbCaptureError)
 * @param (String) name 方法名
 * @param (Object) params 调用参数
 * @param (Function) onError 捕获错误处理函数
 * @param (Number) timeoutDelay 方法返回判断超时延迟时间，单位为s， 默认5s 【timeoutDelay===0 不触发超时报错】
 * @return (Object) resp 方法返回数据
 */


var dsbridgeSync = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(name, params, onError, timeoutDelay) {
    var handleError, ref, withSystemBrowserInApp, h5NeedToken, token;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (params === void 0) params = {};
            if (timeoutDelay === void 0) timeoutDelay = 5;

            if (typeof onError === 'number') {
              timeoutDelay = onError;
            } // 使用时可以省略onError直接传timeoutDelay => dsbridgeSync('name', {}, 5)
            // 处理error


            handleError = function handleError(error) {
              if (onError && typeof onError === 'function') {
                onError({
                  tag: name,
                  extra: JSON.stringify(params),
                  error: error
                });
              } else if (typeof dsbridgeSync.CaptureError === 'function') {
                // 如果onError是函数则调用
                dsbridgeSync.CaptureError({
                  tag: name,
                  extra: JSON.stringify(params),
                  error: error,
                  level: 'info'
                });
              }
            };

            if (!(name === 'lbGetNativePage')) {
              _context2.next = 14;
              break;
            }

            if (!(params.page && params.pageConfig)) {
              _context2.next = 14;
              break;
            }

            ref = params.pageConfig;
            withSystemBrowserInApp = ref.withSystemBrowserInApp;
            h5NeedToken = ref.h5NeedToken;

            if (!(withSystemBrowserInApp && h5NeedToken)) {
              _context2.next = 14;
              break;
            }

            _context2.next = 12;
            return lbGetToken();

          case 12:
            token = _context2.sent;

            if (token) {
              params.page = params.page.includes('?') ? params.page + "&token=" + encodeURIComponent(token) : params.page + "?token=" + encodeURIComponent(token);
            }

          case 14:
            return _context2.abrupt("return", new Promise(function (resolve, reject) {
              // 不在 App 内
              if (!isApp()) {
                return reject('jsbridge 不在app');
              } // 调用方法不存在


              // 调用方法不存在
              if (!dsbridge.hasNativeMethod(name)) {
                return reject('jsbridge 方法不支持');
              } // 判断客服端页面是否支持


              // 判断客服端页面是否支持
              if (name === 'lbCheckSupportPath') {
                return resolve(hasNativePath(params));
              }

              if (HTTPS_LIST.includes(name)) {
                var key = name === 'lbGetNativePage' ? 'page' : 'url';

                if (params[key] && params[key].startsWith('//')) {
                  params[key] = "https:" + params[key];
                }
              }

              if (name === 'lbGetNativePage') {
                if (params.page && params.pageConfig) {
                  var parseObj = urlParse(params.page, true);
                  var query = parseObj.query;
                  var origin = parseObj.origin;
                  var pathname = parseObj.pathname;
                  var newQueryObject = Object.assign({}, query, params.pageConfig);
                  var newQuery = urlParse.qs.stringify(newQueryObject, true);
                  params.page = "" + origin + pathname + newQuery;
                }
              }

              if (name === 'lbShowSharedUrl' || name === 'lbShowInvitationPoster') {
                if (params.url) {
                  params.url = deleteParams(params.url);
                }

                if (name === 'lbShowInvitationPoster' && params.data) {
                  params.data = params.data.map(function (item) {
                    return Object.assign({}, item, {
                      url: deleteParams(item.url)
                    });
                  });
                }
              } // 同步jsbridge调用


              // 同步jsbridge调用
              if (CALL_LIST.includes(name)) {
                try {
                  var resp = dsbridge.call(name, params);

                  if (!resp && !IGNORE_EMPTY_LIST.includes(name)) {
                    // 没有结果，且不在忽略名单中的reject错误
                    return reject('jsbridge 返回为空');
                  }

                  var result = resp || "{}";

                  try {
                    result = JSON.parse(resp || "{}"); // 客户端返回格式处理，包裹status

                    // 客户端返回格式处理，包裹status
                    if (['lbGetMarkets', 'lbGetUserMarkets', 'lbGetSupportList'].includes(name)) {
                      result = {
                        status: true,
                        data: result
                      };
                    }
                  } catch (error) {
                    handleError(error);
                  }

                  return resolve(result);
                } catch (e) {
                  return reject(e);
                } // 异步jsbridge调用

              } else {
                var cb = false;
                dsbridge.call(name, params, function (resp) {
                  try {
                    cb = true; // 返回值需要 JSON.parse
                    // resp: { data = {}, status = false, error = '', build = '', version = '' }

                    // 返回值需要 JSON.parse
                    // resp: { data = {}, status = false, error = '', build = '', version = '' }
                    if (!resp && !IGNORE_EMPTY_LIST.includes(name)) {
                      // 没有结果，且不在忽略名单中的reject错误
                      return reject('jsbridge 返回为空');
                    }

                    var respJson = JSON.parse(resp || "{}");
                    return resolve(respJson);
                  } catch (e) {
                    return reject(e);
                  }
                });

                if (timeoutDelay && timeoutDelay > 0) {
                  var time = OPERATE_LIST.includes(name) ? 10 : timeoutDelay;
                  setTimeout(function () {
                    if (cb) {
                      return;
                    }

                    handleError("jsbridge callback 超时 " + time + "s");
                  }, time * 1000);
                }
              }
            }).catch(function (error) {
              handleError(error);
              return {
                status: false,
                error: error
              };
            }));

          case 15:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function dsbridgeSync(_x, _x2, _x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}(); // 检测方法是否存在


var hasNativeMethod = function hasNativeMethod() {
  var ref;
  var args = [],
      len = arguments.length;

  while (len--) {
    args[len] = arguments[len];
  }

  return isApp() ? (ref = dsbridge.hasNativeMethod).call.apply(ref, [dsbridge].concat(args)) : 0;
};
/**
 * 打开url地址 区分app内外
 * @param {string} url
 * @param {boolean} closeOthers 关闭其他webview
 */


var openUrlPage = function openUrlPage(url, closeOthers) {
  if (closeOthers === void 0) closeOthers = false;

  try {
    if (!url) {
      console.warn('url error: ', url);
      return;
    } // 处理传递的 url 为 encode 的情况


    url = decodeURIComponent(url); // 解析 query 重新 encode query 然后跳转

    var parseObj = urlParse(url, true); // 获取当前 url 上的 channel 合并到跳转链接

    var currentUrlParse = urlParse(location.href, true);
    var channel = currentUrlParse.query && currentUrlParse.query.channel;
    var newQuery = parseObj.query;

    if (channel) {
      newQuery = Object.assign({}, {
        channel: channel
      }, parseObj.query);
    }

    var query = urlParse.qs.stringify(newQuery, true);
    var newUrl = "" + parseObj.origin + parseObj.pathname + query;

    if (isApp()) {
      dsbridgeSync('lbGetNativePage', {
        page: newUrl,
        closeOthers: closeOthers
      }).then(function (ref) {
        var status = ref.status; // 安卓返回undefined，ios返回boolean值，兼容安卓不返回的情况

        if (status === false) {
          location.href = newUrl;
        }
      });
    } else {
      location.href = newUrl;
    }
  } catch (error) {
    console.log('openUrlPage', error);
  }
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3355
 * @description lbUploadProgress
 * @param {number} value default=未填写    描述：当前进度 0~1
 * @param {string} name default=未填写    描述：获取图片对象的 name
 * @param {string} key default=未填写    描述：图片上传的 key
  */


var lbUploadProgress = function lbUploadProgress(ref) {
  if (ref === void 0) ref = {};
  var value = ref.value;
  var name = ref.name;
  var key = ref.key;
  return dsbridgeSync('lbUploadProgress', {
    value: value,
    name: name,
    key: key
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3358
 * @description lbEventRecord
 * @param {string} eventID default=未填写    描述：上报页面 id
 * @param {string} any default=未填写    描述：可添加任意参数
  */


var lbEventRecord = function lbEventRecord(ref) {
  if (ref === void 0) ref = {};
  var eventID = ref.eventID;
  var any = ref.any;
  return dsbridgeSync('lbEventRecord', {
    eventID: eventID,
    any: any
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3369
 * @description lbGetNativePage
 * @param {string} page default=未填写    描述：参考  https://book.5th.im/app-team/LongBridge-App/jwgi  https://book.5th.im/app-team/LongBridge-App/gaz2
 * @param {boolean} redirect default=未填写    描述：是否关闭当前页面 （1.5 版本可用 ）
 * @param {boolean} closeOthers default=未填写    描述：是否关闭其他页面 （2.6.0 版本可用 ）
 * @param {object} pageConfig default=未填写    描述：透传参数配置WebView页面的ui，不会被当做参数带到url上
  */


var lbGetNativePage = function lbGetNativePage(ref) {
  if (ref === void 0) ref = {};
  var page = ref.page;
  var redirect = ref.redirect;
  var closeOthers = ref.closeOthers;
  var pageConfig = ref.pageConfig;
  return dsbridgeSync('lbGetNativePage', {
    page: page,
    redirect: redirect,
    closeOthers: closeOthers,
    pageConfig: pageConfig
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3370
 * @description lbCloseWebView
 * @param {boolean} root default=未填写    描述：是否返回根目录
  */


var lbCloseWebView = function lbCloseWebView(ref) {
  if (ref === void 0) ref = {};
  var root = ref.root;
  return dsbridgeSync('lbCloseWebView', {
    root: root
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3372
 * @description lbCheckSupportPath
 * @param {string} key default=未填写    描述：客户端路由路径
  */


var lbCheckSupportPath = function lbCheckSupportPath(ref) {
  if (ref === void 0) ref = {};
  var key = ref.key;
  return dsbridgeSync('lbCheckSupportPath', {
    key: key
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3387
 * @description lbAlert
 * @param {string} title default=未填写    描述：提示的标题
 * @param {boolean} canKeyboardCancel default=未填写    描述：Android设备是否可以用返回键关闭弹窗，默认是true
 * @param {string} message default=未填写    描述：提示的内容
 * @param {number} type default=0    描述：// 0：actionsheet 1：alert，android的actionsheet只支持传两个以上的actions，android的alert不支持传两个以上的actions
 * @param {array} actions default=未填写    描述：提示的按钮名称
  */


var lbAlert = function lbAlert(ref) {
  if (ref === void 0) ref = {};
  var title = ref.title;
  var canKeyboardCancel = ref.canKeyboardCancel;
  var message = ref.message;
  var type = ref.type;
  var actions = ref.actions;
  return dsbridgeSync('lbAlert', {
    title: title,
    canKeyboardCancel: canKeyboardCancel,
    message: message,
    type: type,
    actions: actions
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3389
 * @description lbOpenFile
 * @param {string} fileName default=未填写    描述：文件名称 ，可通过 downloadFile 获得
  */


var lbOpenFile = function lbOpenFile(ref) {
  if (ref === void 0) ref = {};
  var fileName = ref.fileName;
  return dsbridgeSync('lbOpenFile', {
    fileName: fileName
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3390
 * @description lbHideKeyboard
  */


var lbHideKeyboard = function lbHideKeyboard() {
  var args = [],
      len = arguments.length;

  while (len--) {
    args[len] = arguments[len];
  }

  return dsbridgeSync.apply(void 0, ['lbHideKeyboard'].concat(args));
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3391
 * @description lbGetFileList
 * @param {string} fileName default=未填写    描述：要读取的文件名，默认返回沙盒所有文件列表
  */


var lbGetFileList = function lbGetFileList(ref) {
  if (ref === void 0) ref = {};
  var fileName = ref.fileName;
  return dsbridgeSync('lbGetFileList', {
    fileName: fileName
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3392
 * @description lbRequest
 * @param {string} path default=未填写    描述：接口相对地址 "/v1/search/gethotwords"
 * @param {string} baseUrl default=未填写    描述：请求域名 url，替换内置，完整的 url = baseUrl+path
 * @param {object} data default=未填写    描述：请求的参数 body
 * @param {object} formData default=未填写    描述：未填写
 * @param {object} header default=未填写    描述：设置请求的 header
 * @param {number} timeout default=未填写    描述：超时时间，单位为秒
 * @param {string} method default=未填写    描述：HTTP 请求方法
 * @param {number} cacheTimeInSeconds default=未填写    描述：缓存时间，默认 0 不开启缓存，单位秒。开启缓存只会返回缓存（如果有缓存）。
  */


var lbRequest = function lbRequest(ref) {
  if (ref === void 0) ref = {};
  var path = ref.path;
  var baseUrl = ref.baseUrl;
  var data = ref.data;
  var formData = ref.formData;
  var header = ref.header;
  var timeout = ref.timeout;
  var method = ref.method;
  var cacheTimeInSeconds = ref.cacheTimeInSeconds;
  return dsbridgeSync('lbRequest', {
    path: path,
    baseUrl: baseUrl,
    data: data,
    formData: formData,
    header: header,
    timeout: timeout,
    method: method,
    cacheTimeInSeconds: cacheTimeInSeconds
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3393
 * @description lbRemoveFile
 * @param {string} fileName default=未填写    描述：需要删除的文件名
  */


var lbRemoveFile = function lbRemoveFile(ref) {
  if (ref === void 0) ref = {};
  var fileName = ref.fileName;
  return dsbridgeSync('lbRemoveFile', {
    fileName: fileName
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3394
 * @description lbOpenPDF
 * @param {string} url default=未填写    描述：pdf 链接
 * @param {string} title default=未填写    描述：页面头部标题
  */


var lbOpenPDF = function lbOpenPDF(ref) {
  if (ref === void 0) ref = {};
  var url = ref.url;
  var title = ref.title;
  return dsbridgeSync('lbOpenPDF', {
    url: url,
    title: title
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3395
 * @description lbGetNetworkType
  */


var lbGetNetworkType = function lbGetNetworkType() {
  var args = [],
      len = arguments.length;

  while (len--) {
    args[len] = arguments[len];
  }

  return dsbridgeSync.apply(void 0, ['lbGetNetworkType'].concat(args));
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3396
 * @description lbShowToast
 * @param {string} title default=未填写    描述：提示的内容
 * @param {boolean} disableGesture default=未填写    描述：是否显示透明蒙层，防止触摸穿透 （ 安卓不支持）
 * @param {string} type default=default    描述：提示框样式（default, success），安卓 v2.3.0 之后 type=success生效
 * @param {number} duration default=2    描述：持续时间，单位 秒（安卓v2.3.0之后支持）
 * @param {string} imageData default=未填写    描述：图片base64 数据，2020-11-30 20:22:18 3.2.0 版本
  */


var lbShowToast = function lbShowToast(ref) {
  if (ref === void 0) ref = {};
  var title = ref.title;
  var disableGesture = ref.disableGesture;
  var type = ref.type;
  var duration = ref.duration;
  var imageData = ref.imageData;
  return dsbridgeSync('lbShowToast', {
    title: title,
    disableGesture: disableGesture,
    type: type,
    duration: duration,
    imageData: imageData
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3397
 * @description lbSetClipboardData
 * @param {string} data default=未填写    描述：剪贴板的内容
  */


var lbSetClipboardData = function lbSetClipboardData(ref) {
  if (ref === void 0) ref = {};
  var data = ref.data;
  return dsbridgeSync('lbSetClipboardData', {
    data: data
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3398
 * @description lbDownloadFile
 * @param {string} url default=未填写    描述：下载资源的 url
 * @param {object} header default=未填写    描述：HTTP 请求的 Header，Header 中不能设置 Referer
 * @param {number} timeout default=未填写    描述：超时时间，单位为秒
 * @param {boolean} removeExistFile default=未填写    描述：是否重写文件，true 移除当前缓存，并重新下载
 * @param {string} fileName default=未填写    描述：文件名称（唯一），文件已存在会报错返回，默认使用 url 的文件名
  */


var lbDownloadFile = function lbDownloadFile(ref) {
  if (ref === void 0) ref = {};
  var url = ref.url;
  var header = ref.header;
  var timeout = ref.timeout;
  var removeExistFile = ref.removeExistFile;
  var fileName = ref.fileName;
  return dsbridgeSync('lbDownloadFile', {
    url: url,
    header: header,
    timeout: timeout,
    removeExistFile: removeExistFile,
    fileName: fileName
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3399
 * @description lbGetClipboardData
  */


var lbGetClipboardData = function lbGetClipboardData() {
  var args = [],
      len = arguments.length;

  while (len--) {
    args[len] = arguments[len];
  }

  return dsbridgeSync.apply(void 0, ['lbGetClipboardData'].concat(args));
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3400
 * @description lbHideToast
  */


var lbHideToast = function lbHideToast() {
  var args = [],
      len = arguments.length;

  while (len--) {
    args[len] = arguments[len];
  }

  return dsbridgeSync.apply(void 0, ['lbHideToast'].concat(args));
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3401
 * @description lbScanCode
 * @param {boolean} onlyFromCamera default=未填写    描述：是否只从相机读取，默认可以读取相册二维码
  */


var lbScanCode = function lbScanCode(ref) {
  if (ref === void 0) ref = {};
  var onlyFromCamera = ref.onlyFromCamera;
  return dsbridgeSync('lbScanCode', {
    onlyFromCamera: onlyFromCamera
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3402
 * @description lbShowLoading
 * @param {string} title default=未填写    描述：提示的内容
 * @param {boolean} disableGesture default=未填写    描述：是否显示透明蒙层，防止触摸穿透 (安卓不支持)
  */


var lbShowLoading = function lbShowLoading(ref) {
  if (ref === void 0) ref = {};
  var title = ref.title;
  var disableGesture = ref.disableGesture;
  return dsbridgeSync('lbShowLoading', {
    title: title,
    disableGesture: disableGesture
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3404
 * @description lbRefresh
 * @param {string} state default=未填写    描述：设置当前下拉刷新状态
 * @param {boolean} disable default=未填写    描述：设置取消当前下拉刷新
 * @param {string} callback default=未填写    描述：替换回调，默认无回调，默认刷新当前页面
  */


var lbRefresh = function lbRefresh(ref) {
  if (ref === void 0) ref = {};
  var state = ref.state;
  var disable = ref.disable;
  var callback = ref.callback;
  return dsbridgeSync('lbRefresh', {
    state: state,
    disable: disable,
    callback: callback
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3405
 * @description lbSubscribeWS
 * @param {array} topics default=未填写    描述：数量不能为0
 * @param {string} callback default=未填写    描述：回调方法名，方法不能为空
  */


var lbSubscribeWS = function lbSubscribeWS(ref) {
  if (ref === void 0) ref = {};
  var topics = ref.topics;
  var callback = ref.callback;
  return dsbridgeSync('lbSubscribeWS', {
    topics: topics,
    callback: callback
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3406
 * @description lbUnsubscribeWS
 * @param {array} topcis default=未填写    描述：已订阅的主题
  */


var lbUnsubscribeWS = function lbUnsubscribeWS(ref) {
  if (ref === void 0) ref = {};
  var topcis = ref.topcis;
  return dsbridgeSync('lbUnsubscribeWS', {
    topcis: topcis
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3407
 * @description lbSetStorage
 * @param {object} value default=未填写    描述：保存 value 内所有值  {  "value":{"name":"xiaohau", "age":"18", "height":"146"}  }
  */


var lbSetStorage = function lbSetStorage(ref) {
  if (ref === void 0) ref = {};
  var value = ref.value;
  return dsbridgeSync('lbSetStorage', {
    value: value
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3408
 * @description lbRemoveStorage
 * @param {string} key default=未填写    描述：本地缓存中指定的 key
  */


var lbRemoveStorage = function lbRemoveStorage(ref) {
  if (ref === void 0) ref = {};
  var key = ref.key;
  return dsbridgeSync('lbRemoveStorage', {
    key: key
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3409
 * @description lbGetUserInfo
 * @param {boolean} refresh default=未填写    描述：是否调用接口刷新数据，默认使用本地缓存数据
  */


var lbGetUserInfo = function lbGetUserInfo(ref) {
  if (ref === void 0) ref = {};
  var refresh = ref.refresh;
  return dsbridgeSync('lbGetUserInfo', {
    refresh: refresh
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3410
 * @description lbGetStorage
 * @param {string} key default=未填写    描述：本地缓存中指定的 key 
  */


var lbGetStorage = function lbGetStorage(ref) {
  if (ref === void 0) ref = {};
  var key = ref.key;
  return dsbridgeSync('lbGetStorage', {
    key: key
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3411
 * @description lbGetStorageInfo
  */


var lbGetStorageInfo = function lbGetStorageInfo() {
  var args = [],
      len = arguments.length;

  while (len--) {
    args[len] = arguments[len];
  }

  return dsbridgeSync.apply(void 0, ['lbGetStorageInfo'].concat(args));
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3412
 * @description lbClearStorage
  */


var lbClearStorage = function lbClearStorage() {
  var args = [],
      len = arguments.length;

  while (len--) {
    args[len] = arguments[len];
  }

  return dsbridgeSync.apply(void 0, ['lbClearStorage'].concat(args));
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3413
 * @description lbGetLocation
 * @param {boolean} onlyLocation default=未填写    描述：只需要经纬度
 * @param {boolean} displayMap default=未填写    描述：是否需要地图点选(Android v2.3.0版本后不支持，高版本高德使用了热更新，googleplay禁止，降低了sdk版本，低版本高德没有这个api)
  */


var lbGetLocation = function lbGetLocation(ref) {
  if (ref === void 0) ref = {};
  var onlyLocation = ref.onlyLocation;
  var displayMap = ref.displayMap;
  return dsbridgeSync('lbGetLocation', {
    onlyLocation: onlyLocation,
    displayMap: displayMap
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3416
 * @description lbSetNavigationLoading
 * @param {number} progress default=未填写    描述：进度 // 0-1
 * @param {boolean} animated default=未填写    描述：是否有动画
  */


var lbSetNavigationLoading = function lbSetNavigationLoading(ref) {
  if (ref === void 0) ref = {};
  var progress = ref.progress;
  var animated = ref.animated;
  return dsbridgeSync('lbSetNavigationLoading', {
    progress: progress,
    animated: animated
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3417
 * @description lbSaveImage
 * @param {string} url default=未填写    描述：图片网络地址
  */


var lbSaveImage = function lbSaveImage(ref) {
  if (ref === void 0) ref = {};
  var url = ref.url;
  return dsbridgeSync('lbSaveImage', {
    url: url
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3418
 * @description lbGetSignature
 * @param {string} userName default=未填写    描述：用户真实姓名
  */


var lbGetSignature = function lbGetSignature(ref) {
  if (ref === void 0) ref = {};
  var userName = ref.userName;
  return dsbridgeSync('lbGetSignature', {
    userName: userName
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3419
 * @description lbGetPhotos
 * @param {number} count default=未填写    描述：需要图片数量
 * @param {number} type default=未填写    描述：图片选择类型 0 自主选择 1 拍照 2 相册选择
 * @param {string} service default=未填写    描述：例：lb.portfolio.atm , social字段表示使用社区交服务
 * @param {string} name default=未填写    描述：获取图片的控件对象 用于上传进度回调 (安卓1.2版本必传)
 * @param {boolean} loading default=未填写    描述：上传图片是否需要 提示toast
 * @param {string} photoType default=未填写    描述：circle圈子的头像，需要进入裁剪；
shareList 股单
  */


var lbGetPhotos = function lbGetPhotos(ref) {
  if (ref === void 0) ref = {};
  var count = ref.count;
  var type = ref.type;
  var service = ref.service;
  var name = ref.name;
  var loading = ref.loading;
  var photoType = ref.photoType;
  return dsbridgeSync('lbGetPhotos', {
    count: count,
    type: type,
    service: service,
    name: name,
    loading: loading,
    photoType: photoType
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3420
 * @description lbPreviewImage
 * @param {array} urls default=未填写    描述：不能为空,需要预览的图片链接列表
 * @param {number} current default=0    描述：当前显示图片的序号
 * @param {array} rightConfigs default=未填写    描述：最多两个
 * @param {string} type default=未填写    描述：预览图片类型，3.0.1 新增字段
  */


var lbPreviewImage = function lbPreviewImage(ref) {
  if (ref === void 0) ref = {};
  var urls = ref.urls;
  var current = ref.current;
  var rightConfigs = ref.rightConfigs;
  var type = ref.type;
  return dsbridgeSync('lbPreviewImage', {
    urls: urls,
    current: current,
    rightConfigs: rightConfigs,
    type: type
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3421
 * @description lbSetNativeBar
 * @param {object} titleConfig default=未填写    描述：导航栏标题
 * @param {boolean} hidden default=未填写    描述：是否隐藏
 * @param {string} type default=default    描述：// default // large
 * @param {string} backgroundColor default=未填写    描述：背景色
 * @param {object} leftConfig default=未填写    描述：导航栏左侧配置
 * @param {array} rightConfigs default=未填写    描述：导航栏右侧配置 默认 无按钮 多于2个显示...  点击显示更多菜单
  */


var lbSetNativeBar = function lbSetNativeBar(ref) {
  if (ref === void 0) ref = {};
  var titleConfig = ref.titleConfig;
  var hidden = ref.hidden;
  var type = ref.type;
  var backgroundColor = ref.backgroundColor;
  var leftConfig = ref.leftConfig;
  var rightConfigs = ref.rightConfigs;
  return dsbridgeSync('lbSetNativeBar', {
    titleConfig: titleConfig,
    hidden: hidden,
    type: type,
    backgroundColor: backgroundColor,
    leftConfig: leftConfig,
    rightConfigs: rightConfigs
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3422
 * @description lbShowSharedUrl
 * @param {string} url default=未填写    描述：生成二维码的字符串
 * @param {string} title default=未填写    描述：分享标题
 * @param {string} descr default=未填写    描述：分享摘要
 * @param {string} thumbImageUrl default=未填写    描述：分享 icon 缩略图
 * @param {boolean} screenShot default=未填写    描述：是否需要截图 1.5 以后支持
 * @param {string} type default=inviteFriends    描述：分享圈子和海报功能（不填还是普通分享功能）
 * @param {object} posters default=未填写    描述：海报地址
  */


var lbShowSharedUrl = function lbShowSharedUrl(ref) {
  if (ref === void 0) ref = {};
  var url = ref.url;
  var title = ref.title;
  var descr = ref.descr;
  var thumbImageUrl = ref.thumbImageUrl;
  var screenShot = ref.screenShot;
  var type = ref.type;
  var posters = ref.posters;
  return dsbridgeSync('lbShowSharedUrl', {
    url: url,
    title: title,
    descr: descr,
    thumbImageUrl: thumbImageUrl,
    screenShot: screenShot,
    type: type,
    posters: posters
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3423
 * @description lbGetMarkets
  */


var lbGetMarkets = function lbGetMarkets() {
  var args = [],
      len = arguments.length;

  while (len--) {
    args[len] = arguments[len];
  }

  return dsbridgeSync.apply(void 0, ['lbGetMarkets'].concat(args));
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3424
 * @description lbShowInvitationPoster
 * @param {string} url default=未填写    描述：生成二维码的字符串
 * @param {object} data default=未填写    描述：分享标题
  */


var lbShowInvitationPoster = function lbShowInvitationPoster(ref) {
  if (ref === void 0) ref = {};
  var url = ref.url;
  var data = ref.data;
  return dsbridgeSync('lbShowInvitationPoster', {
    url: url,
    data: data
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3425
 * @description lbGetUserMarkets
  */


var lbGetUserMarkets = function lbGetUserMarkets() {
  var args = [],
      len = arguments.length;

  while (len--) {
    args[len] = arguments[len];
  }

  return dsbridgeSync.apply(void 0, ['lbGetUserMarkets'].concat(args));
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3426
 * @description lbFollowStock
 * @param {string} counterId default=未填写    描述：股票 counterId
  */


var lbFollowStock = function lbFollowStock(ref) {
  if (ref === void 0) ref = {};
  var counterId = ref.counterId;
  return dsbridgeSync('lbFollowStock', {
    counterId: counterId
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3427
 * @description lbShowLongInvitationPoster
 * @param {array} data default=未填写    描述：未填写
  */


var lbShowLongInvitationPoster = function lbShowLongInvitationPoster(ref) {
  if (ref === void 0) ref = {};
  var data = ref.data;
  return dsbridgeSync('lbShowLongInvitationPoster', {
    data: data
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3428
 * @description lbCheckTradeToken
 * @param {number} type default=0    描述：0：检查当前用户是否有交易 token   1: 无 token 时弹出输入密码弹窗，有 token 时直接返回        2：无 token 时弹出保护页面获取 token，有 token 时直接返回
  */


var lbCheckTradeToken = function lbCheckTradeToken(ref) {
  if (ref === void 0) ref = {};
  var type = ref.type;
  return dsbridgeSync('lbCheckTradeToken', {
    type: type
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3429
 * @description lbSubscribeData
 * @param {string} name default=未填写    描述：订阅类型 // asset(资产数据) fund_asset(基金持仓变更)
 * @param {string} callback default=未填写    描述：回调方法名
 * @param {string} target default=未填写    描述：当前订阅者标记
  */


var lbSubscribeData = function lbSubscribeData(ref) {
  if (ref === void 0) ref = {};
  var name = ref.name;
  var callback = ref.callback;
  var target = ref.target;
  return dsbridgeSync('lbSubscribeData', {
    name: name,
    callback: callback,
    target: target
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3430
 * @description lbUnsubscribeData
 * @param {string} name default=未填写    描述：订阅类型 // asset(资产数据) fund_asset(基金持仓变更)
 * @param {string} callback default=未填写    描述：回调方法名
 * @param {string} target default=未填写    描述：当前订阅者标记
  */


var lbUnsubscribeData = function lbUnsubscribeData(ref) {
  if (ref === void 0) ref = {};
  var name = ref.name;
  var callback = ref.callback;
  var target = ref.target;
  return dsbridgeSync('lbUnsubscribeData', {
    name: name,
    callback: callback,
    target: target
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3431
 * @description lbGetFeatureFlags
  */


var lbGetFeatureFlags = function lbGetFeatureFlags() {
  var args = [],
      len = arguments.length;

  while (len--) {
    args[len] = arguments[len];
  }

  return dsbridgeSync.apply(void 0, ['lbGetFeatureFlags'].concat(args));
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3433
 * @description lbBIEventRecord
 * @param {string} type default=未填写    描述：性能类型
 * @param {object} data default=未填写    描述：可添加任意参数
  */


var lbBIEventRecord = function lbBIEventRecord(ref) {
  if (ref === void 0) ref = {};
  var type = ref.type;
  var data = ref.data;
  return dsbridgeSync('lbBIEventRecord', {
    type: type,
    data: data
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3434
 * @description lbVibrate
 * @param {string} style default=未填写    描述：默认 medium， style 参数优先，传 style 时 time 不生效（安卓不支持此参数）
 * @param {number} time default=未填写    描述：模拟震动时间，不精确， 单位为s
  */


var lbVibrate = function lbVibrate(ref) {
  if (ref === void 0) ref = {};
  var style = ref.style;
  var time = ref.time;
  return dsbridgeSync('lbVibrate', {
    style: style,
    time: time
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3439
 * @description lbShowSharedHolding
 * @param {string} name default=未填写    描述：股票名称
 * @param {string} counterId default=未填写    描述：未填写
 * @param {string} value default=未填写    描述：盈亏值
 * @param {string} code default=未填写    描述：股票代码 非持仓状态下非必传
 * @param {string} lastDone default=未填写    描述：现价 非持仓状态下非必传
 * @param {string} averageCost default=未填写    描述：成本 非持仓状态下非必传
 * @param {string} date default=未填写    描述：时间
 * @param {integer} isHolding default=未填写    描述：是否持仓 默认0
 * @param {string} title default=未填写    描述：用户名称
  */


var lbShowSharedHolding = function lbShowSharedHolding(ref) {
  if (ref === void 0) ref = {};
  var name = ref.name;
  var counterId = ref.counterId;
  var value = ref.value;
  var code = ref.code;
  var lastDone = ref.lastDone;
  var averageCost = ref.averageCost;
  var date = ref.date;
  var isHolding = ref.isHolding;
  var title = ref.title;
  return dsbridgeSync('lbShowSharedHolding', {
    name: name,
    counterId: counterId,
    value: value,
    code: code,
    lastDone: lastDone,
    averageCost: averageCost,
    date: date,
    isHolding: isHolding,
    title: title
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3440
 * @description lbConfigNativeBar
 * @param {object} titleConfig default=未填写    描述：导航栏标题
 * @param {object} leftConfig default=未填写    描述：导航栏左侧配置
 * @param {object} leftSubConfig default=未填写    描述：导航栏左侧子配置
 * @param {array} rightConfigs default=未填写    描述：导航栏右侧配置 默认 无按钮 多于2个显示...  点击显示更多菜单
 * @param {boolean} hidden default=未填写    描述：是否隐藏
 * @param {string} type default=default    描述：导航栏展示类型 // default // large
 * @param {string} backgroundColor default=当前主题背景色    描述：背景色
 * @param {boolean} fitsStatusBar default=未填写    描述：是否全屏展示 
 * @param {array} tabsConfigs default=未填写    描述：导航栏tabs
  */


var lbConfigNativeBar = function lbConfigNativeBar(ref) {
  if (ref === void 0) ref = {};
  var titleConfig = ref.titleConfig;
  var leftConfig = ref.leftConfig;
  var leftSubConfig = ref.leftSubConfig;
  var rightConfigs = ref.rightConfigs;
  var hidden = ref.hidden;
  var type = ref.type;
  var backgroundColor = ref.backgroundColor;
  var fitsStatusBar = ref.fitsStatusBar;
  var tabsConfigs = ref.tabsConfigs;
  return dsbridgeSync('lbConfigNativeBar', {
    titleConfig: titleConfig,
    leftConfig: leftConfig,
    leftSubConfig: leftSubConfig,
    rightConfigs: rightConfigs,
    hidden: hidden,
    type: type,
    backgroundColor: backgroundColor,
    fitsStatusBar: fitsStatusBar,
    tabsConfigs: tabsConfigs
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3443
 * @description lbGetImage
 * @param {number} count default=未填写    描述：需要图片数量 最大9  仅当type=0或2生效
 * @param {number} type default=未填写    描述：图片选择类型 0 自主选择 1 拍照 2 相册选择
 * @param {string} photoType default=未填写    描述：（v2.4.0后支持）type=0或1的时候生效，枚举类型，空跳转到系统拍照，document文件拍照，face人脸拍照，传入不识别参数报错
 * @param {string} service default=未填写    描述：例：lb.portfolio.atm
 * @param {string} prefix default=未填写    描述：上传接口prefix参数，香展版本之后新增
 * @param {string} name default=未填写    描述：获取图片的控件对象 用于上传进度回调 (安卓1.2版本必传)
 * @param {string} cameraType default="back"    描述：相机类型 前置 后置 ， 仅type=1生效
  */


var lbGetImage = function lbGetImage(ref) {
  if (ref === void 0) ref = {};
  var count = ref.count;
  var type = ref.type;
  var photoType = ref.photoType;
  var service = ref.service;
  var prefix = ref.prefix;
  var name = ref.name;
  var cameraType = ref.cameraType;
  return dsbridgeSync('lbGetImage', {
    count: count,
    type: type,
    photoType: photoType,
    service: service,
    prefix: prefix,
    name: name,
    cameraType: cameraType
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3462
 * @description lbHideLoading
  */


var lbHideLoading = function lbHideLoading() {
  var args = [],
      len = arguments.length;

  while (len--) {
    args[len] = arguments[len];
  }

  return dsbridgeSync.apply(void 0, ['lbHideLoading'].concat(args));
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3606
 * @description lbTranslateHtml
  */


var lbTranslateHtml = function lbTranslateHtml() {
  var args = [],
      len = arguments.length;

  while (len--) {
    args[len] = arguments[len];
  }

  return dsbridgeSync.apply(void 0, ['lbTranslateHtml'].concat(args));
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3609
 * @description lbShowNewsDetailSettingPanel
  */


var lbShowNewsDetailSettingPanel = function lbShowNewsDetailSettingPanel() {
  var args = [],
      len = arguments.length;

  while (len--) {
    args[len] = arguments[len];
  }

  return dsbridgeSync.apply(void 0, ['lbShowNewsDetailSettingPanel'].concat(args));
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3783
 * @description lbAddCalendar
 * @param {string} title default=未填写    描述：标题
 * @param {number} startTime default=未填写    描述：开始时间（时间戳）单位s
 * @param {number} endTime default=未填写    描述：结束时间
  */


var lbAddCalendar = function lbAddCalendar(ref) {
  if (ref === void 0) ref = {};
  var title = ref.title;
  var startTime = ref.startTime;
  var endTime = ref.endTime;
  return dsbridgeSync('lbAddCalendar', {
    title: title,
    startTime: startTime,
    endTime: endTime
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3789
 * @description lbDeleteCalendar
 * @param {string} title default=未填写    描述：标题
 * @param {number} startTime default=未填写    描述：开始时间（时间戳）单位s（ios必传）
 * @param {number} endTime default=未填写    描述：结束时间（ios必传）
  */


var lbDeleteCalendar = function lbDeleteCalendar(ref) {
  if (ref === void 0) ref = {};
  var title = ref.title;
  var startTime = ref.startTime;
  var endTime = ref.endTime;
  return dsbridgeSync('lbDeleteCalendar', {
    title: title,
    startTime: startTime,
    endTime: endTime
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3792
 * @description lbQueryCalendar
 * @param {string} title default=未填写    描述：标题
 * @param {number} startTime default=未填写    描述：开始时间（时间戳）单位s（ios必传）
 * @param {number} endTime default=未填写    描述：结束时间（ios必传）
  */


var lbQueryCalendar = function lbQueryCalendar(ref) {
  if (ref === void 0) ref = {};
  var title = ref.title;
  var startTime = ref.startTime;
  var endTime = ref.endTime;
  return dsbridgeSync('lbQueryCalendar', {
    title: title,
    startTime: startTime,
    endTime: endTime
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3798
 * @description lbTranslateDialog
  */


var lbTranslateDialog = function lbTranslateDialog() {
  var args = [],
      len = arguments.length;

  while (len--) {
    args[len] = arguments[len];
  }

  return dsbridgeSync.apply(void 0, ['lbTranslateDialog'].concat(args));
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3843
 * @description lbTopicFocus
 * @param {string} topicId default=未填写    描述：主题id
 * @param {boolean} focus default=未填写    描述：订阅/取消订阅
  */


var lbTopicFocus = function lbTopicFocus(ref) {
  if (ref === void 0) ref = {};
  var topicId = ref.topicId;
  var focus = ref.focus;
  return dsbridgeSync('lbTopicFocus', {
    topicId: topicId,
    focus: focus
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/4095
 * @description lbSetTools
 * @param {array} tools default=未填写    描述：开启功能
 * @param {boolean} show default=未填写    描述：未填写
  */


var lbSetTools = function lbSetTools(ref) {
  if (ref === void 0) ref = {};
  var tools = ref.tools;
  var show = ref.show;
  return dsbridgeSync('lbSetTools', {
    tools: tools,
    show: show
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/4131
 * @description lbAddArticle
 * @param {string} target_id default=未填写    描述：创建topic请求参数target_id
 * @param {string} target_type default=未填写    描述：创建topic请求参数target_type
 * @param {string} type default=未填写    描述：发表类型，comment 评论，tweet 短评(topic)，post 长评(topic)
 * @param {object} topic default=未填写    描述：topic信息，type=comment类型下指对topic的评论
 * @param {object} comment default=未填写    描述：comment信息，type=comment类型下指对comment的回复
  */


var lbAddArticle = function lbAddArticle(ref) {
  if (ref === void 0) ref = {};
  var target_id = ref.target_id;
  var target_type = ref.target_type;
  var type = ref.type;
  var topic = ref.topic;
  var comment = ref.comment;
  return dsbridgeSync('lbAddArticle', {
    target_id: target_id,
    target_type: target_type,
    type: type,
    topic: topic,
    comment: comment
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/4149
 * @description lbShowShare
 * @param {string} url default=未填写    描述：分享url
 * @param {string} title default=未填写    描述：分享标题
 * @param {string} descr default=未填写    描述：分享摘要
 * @param {string} thumbImageUrl default=未填写    描述：分享 icon 缩略图
 * @param {string} platform default=未填写    描述：平台 可为空，不传空直接分享到对应平台
 * @param {string} type default=未填写    描述：分享类型（动态/圈子/课程等）
topic 动态分享，circle 圈子分享，profile 个人主页分享，course 课程分享，courseChapter 课程章节分享，event 事件分享，news 新闻分享，sharelist 股单
 * @param {boolean} wechatMiniProgram default=未填写    描述：分享到微信是否是小程序
 * @param {string} miniProgramPath default=未填写    描述：小程序page path
 * @param {array} actions default=未填写    描述：额外携带按钮  repost 转发； qr 二维码；card 分享卡片
 * @param {object} bi default=未填写    描述：bi埋点信息，object_id, control_id 等（具体参数参见埋点相关文档）
 * @param {object} topic default=未填写    描述：待分享的topic动态信息
 * @param {object} circle default=未填写    描述：待分享的圈子信息
 * @param {object} profile default=未填写    描述：个人user信息
 * @param {object} course default=未填写    描述：课程信息
 * @param {object} courseChapter default=未填写    描述：课程章节信息
 * @param {object} event default=未填写    描述：事件信息
 * @param {object} news default=未填写    描述：新闻信息
 * @param {object} sharelist default=未填写    描述：股单信息
  */


var lbShowShare = function lbShowShare(ref) {
  if (ref === void 0) ref = {};
  var url = ref.url;
  var title = ref.title;
  var descr = ref.descr;
  var thumbImageUrl = ref.thumbImageUrl;
  var platform = ref.platform;
  var type = ref.type;
  var wechatMiniProgram = ref.wechatMiniProgram;
  var miniProgramPath = ref.miniProgramPath;
  var actions = ref.actions;
  var bi = ref.bi;
  var topic = ref.topic;
  var circle = ref.circle;
  var profile = ref.profile;
  var course = ref.course;
  var courseChapter = ref.courseChapter;
  var event = ref.event;
  var news = ref.news;
  var sharelist = ref.sharelist;
  return dsbridgeSync('lbShowShare', {
    url: url,
    title: title,
    descr: descr,
    thumbImageUrl: thumbImageUrl,
    platform: platform,
    type: type,
    wechatMiniProgram: wechatMiniProgram,
    miniProgramPath: miniProgramPath,
    actions: actions,
    bi: bi,
    topic: topic,
    circle: circle,
    profile: profile,
    course: course,
    courseChapter: courseChapter,
    event: event,
    news: news,
    sharelist: sharelist
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/4158
 * @description lbSelectCircle
 * @param {object} circle default=未填写    描述：用户选择的圈子信息
  */


var lbSelectCircle = function lbSelectCircle(ref) {
  if (ref === void 0) ref = {};
  var circle = ref.circle;
  return dsbridgeSync('lbSelectCircle', {
    circle: circle
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/4167
 * @description lbEditor
 * @param {string} type default=未填写    描述：未填写
 * @param {object} params default=未填写    描述：未填写
  */


var lbEditor = function lbEditor(ref) {
  if (ref === void 0) ref = {};
  var type = ref.type;
  var params = ref.params;
  return dsbridgeSync('lbEditor', {
    type: type,
    params: params
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/4266
 * @description lbStateUpdated
 * @param {string} state default=未填写    描述：需要更新的状态名 
 * @param {object} params default=未填写    描述：自定义透传参数 
  */


var lbStateUpdated = function lbStateUpdated(ref) {
  if (ref === void 0) ref = {};
  var state = ref.state;
  var params = ref.params;
  return dsbridgeSync('lbStateUpdated', {
    state: state,
    params: params
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/4824
 * @description lbUploadFile
 * @param {string} service default=未填写    描述：例：lb.portfolio.atm 
 * @param {string} name default=未填写    描述：获取图片的控件对象 用于上传进度回调 (安卓1.2版本必传)
 * @param {string} type default=未填写    描述：上传文件类型【pdf】
  */


var lbUploadFile = function lbUploadFile(ref) {
  if (ref === void 0) ref = {};
  var service = ref.service;
  var name = ref.name;
  var type = ref.type;
  return dsbridgeSync('lbUploadFile', {
    service: service,
    name: name,
    type: type
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/4986
 * @description lbGetFortune
 * @param {string} currency default=未填写    描述：未填写
  */


var lbGetFortune = function lbGetFortune(ref) {
  if (ref === void 0) ref = {};
  var currency = ref.currency;
  return dsbridgeSync('lbGetFortune', {
    currency: currency
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/5139
 * @description lbFollowUser
  */


var lbFollowUser = function lbFollowUser() {
  var args = [],
      len = arguments.length;

  while (len--) {
    args[len] = arguments[len];
  }

  return dsbridgeSync.apply(void 0, ['lbFollowUser'].concat(args));
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/5202
 * @description lbGetNewsReadStatus
  */


var lbGetNewsReadStatus = function lbGetNewsReadStatus() {
  var args = [],
      len = arguments.length;

  while (len--) {
    args[len] = arguments[len];
  }

  return dsbridgeSync.apply(void 0, ['lbGetNewsReadStatus'].concat(args));
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/5211
 * @description lbSetNewsRead
  */


var lbSetNewsRead = function lbSetNewsRead() {
  var args = [],
      len = arguments.length;

  while (len--) {
    args[len] = arguments[len];
  }

  return dsbridgeSync.apply(void 0, ['lbSetNewsRead'].concat(args));
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/5400
 * @description lbEnableBackGesture
 * @param {boolean} enable default=未填写    描述：未填写
  */


var lbEnableBackGesture = function lbEnableBackGesture(ref) {
  if (ref === void 0) ref = {};
  var enable = ref.enable;
  return dsbridgeSync('lbEnableBackGesture', {
    enable: enable
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/5607
 * @description lbCourseSubscribeStateUpdate
 * @param {string} id default=未填写    描述：课程 id
 * @param {number} status default=未填写    描述：订阅状态，0为未订阅，1为已订阅
  */


var lbCourseSubscribeStateUpdate = function lbCourseSubscribeStateUpdate(ref) {
  if (ref === void 0) ref = {};
  var id = ref.id;
  var status = ref.status;
  return dsbridgeSync('lbCourseSubscribeStateUpdate', {
    id: id,
    status: status
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/5679
 * @description lbRiskResult
 * @param {string} risk default=未填写    描述：未填写
  */


var lbRiskResult = function lbRiskResult(ref) {
  if (ref === void 0) ref = {};
  var risk = ref.risk;
  return dsbridgeSync('lbRiskResult', {
    risk: risk
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/5697
 * @description lbWebViewHeight
 * @param {number} height default=未填写    描述：未填写
 * @param {number} index default=未填写    描述：未填写
  */


var lbWebViewHeight = function lbWebViewHeight(ref) {
  if (ref === void 0) ref = {};
  var height = ref.height;
  var index = ref.index;
  return dsbridgeSync('lbWebViewHeight', {
    height: height,
    index: index
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/5724
 * @description lbSwitchReadMode
  */


var lbSwitchReadMode = function lbSwitchReadMode() {
  var args = [],
      len = arguments.length;

  while (len--) {
    args[len] = arguments[len];
  }

  return dsbridgeSync.apply(void 0, ['lbSwitchReadMode'].concat(args));
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/6348
 * @description lbCaptureStart
 * @param {string} url default=未填写    描述：未填写
  */


var lbCaptureStart = function lbCaptureStart(ref) {
  if (ref === void 0) ref = {};
  var url = ref.url;
  return dsbridgeSync('lbCaptureStart', {
    url: url
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/6354
 * @description lbCaptureFinish
 * @param {integer} height default=未填写    描述：未填写
  */


var lbCaptureFinish = function lbCaptureFinish(ref) {
  if (ref === void 0) ref = {};
  var height = ref.height;
  return dsbridgeSync('lbCaptureFinish', {
    height: height
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/6450
 * @description lbGetAppNotificationConfig
  */


var lbGetAppNotificationConfig = function lbGetAppNotificationConfig() {
  var args = [],
      len = arguments.length;

  while (len--) {
    args[len] = arguments[len];
  }

  return dsbridgeSync.apply(void 0, ['lbGetAppNotificationConfig'].concat(args));
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/6822
 * @description lbSetNativeBarTab
  */


var lbSetNativeBarTab = function lbSetNativeBarTab() {
  var args = [],
      len = arguments.length;

  while (len--) {
    args[len] = arguments[len];
  }

  return dsbridgeSync.apply(void 0, ['lbSetNativeBarTab'].concat(args));
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/6966
 * @description lbShowActionSheet
 * @param {string} title default=未填写    描述：顶部标题
 * @param {boolean} canKeyboardCancel default=未填写    描述：Android设备是否可以用返回键关闭弹窗，默认是true
 * @param {object} cancelAction default=未填写    描述：默认给一个 action 
 * @param {array} actions default=未填写    描述：未填写
  */


var lbShowActionSheet = function lbShowActionSheet(ref) {
  if (ref === void 0) ref = {};
  var title = ref.title;
  var canKeyboardCancel = ref.canKeyboardCancel;
  var cancelAction = ref.cancelAction;
  var actions = ref.actions;
  return dsbridgeSync('lbShowActionSheet', {
    title: title,
    canKeyboardCancel: canKeyboardCancel,
    cancelAction: cancelAction,
    actions: actions
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/7380
 * @description lbConfigContainer
 * @param {string} backgroundColor default=未填写    描述：#454654（待添加'default' = 恢复默认颜色）
  */


var lbConfigContainer = function lbConfigContainer(ref) {
  if (ref === void 0) ref = {};
  var backgroundColor = ref.backgroundColor;
  return dsbridgeSync('lbConfigContainer', {
    backgroundColor: backgroundColor
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/9786
 * @description lbPay
  */


var lbPay = function lbPay() {
  var args = [],
      len = arguments.length;

  while (len--) {
    args[len] = arguments[len];
  }

  return dsbridgeSync.apply(void 0, ['lbPay'].concat(args));
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/9838
 * @description lbUploadVideo
 * @param {string} service default=未填写    描述：例：user.account
 * @param {string} prefix default=未填写    描述：例：id
 * @param {string} name default=未填写    描述：文件名
 * @param {string} onProgress default=未填写    描述：上传进度回调方法名
 * @param {string} duration default=未填写    描述：录制时长
 * @param {string} camera default=未填写    描述：摄像头前后【安卓不支持】
  */


var lbUploadVideo = function lbUploadVideo(ref) {
  if (ref === void 0) ref = {};
  var service = ref.service;
  var prefix = ref.prefix;
  var name = ref.name;
  var onProgress = ref.onProgress;
  var duration = ref.duration;
  var camera = ref.camera;
  return dsbridgeSync('lbUploadVideo', {
    service: service,
    prefix: prefix,
    name: name,
    onProgress: onProgress,
    duration: duration,
    camera: camera
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/10052
 * @description lbShowStockCardView
  */


var lbShowStockCardView = function lbShowStockCardView() {
  var args = [],
      len = arguments.length;

  while (len--) {
    args[len] = arguments[len];
  }

  return dsbridgeSync.apply(void 0, ['lbShowStockCardView'].concat(args));
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/10126
 * @description lbAddBankCard
 * @param {string} usd default=未填写    描述：未填写
  */


var lbAddBankCard = function lbAddBankCard(ref) {
  if (ref === void 0) ref = {};
  var usd = ref.usd;
  return dsbridgeSync('lbAddBankCard', {
    usd: usd
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/10214
 * @description lbEDAAAuth
  */


var lbEDAAAuth = function lbEDAAAuth() {
  var args = [],
      len = arguments.length;

  while (len--) {
    args[len] = arguments[len];
  }

  return dsbridgeSync.apply(void 0, ['lbEDAAAuth'].concat(args));
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/10230
 * @description lbGetCapitalAccountInfo
  */


var lbGetCapitalAccountInfo = function lbGetCapitalAccountInfo() {
  var args = [],
      len = arguments.length;

  while (len--) {
    args[len] = arguments[len];
  }

  return dsbridgeSync.apply(void 0, ['lbGetCapitalAccountInfo'].concat(args));
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/10236
 * @description lbShowSelectCapitalAccountDialog
 * @param {array} disableChannelList default=未填写    描述：禁用的channel列表，不可选，样式为字体颜色置灰
  */


var lbShowSelectCapitalAccountDialog = function lbShowSelectCapitalAccountDialog(ref) {
  if (ref === void 0) ref = {};
  var disableChannelList = ref.disableChannelList;
  return dsbridgeSync('lbShowSelectCapitalAccountDialog', {
    disableChannelList: disableChannelList
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/10300
 * @description lbMmfRiskAssessment
  */


var lbMmfRiskAssessment = function lbMmfRiskAssessment() {
  var args = [],
      len = arguments.length;

  while (len--) {
    args[len] = arguments[len];
  }

  return dsbridgeSync.apply(void 0, ['lbMmfRiskAssessment'].concat(args));
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3356
 * @description lbConfig
 * @param {string} name default=未填写    描述：设置名称
 * @param {boolean} hidden default=未填写    描述：是否隐藏
  */


var lbConfig = function lbConfig(ref) {
  if (ref === void 0) ref = {};
  var name = ref.name;
  var hidden = ref.hidden;
  return dsbridgeSync('lbConfig', {
    name: name,
    hidden: hidden
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3363
 * @description lbGetSystemInfo
  */


var lbGetSystemInfo = function lbGetSystemInfo() {
  var args = [],
      len = arguments.length;

  while (len--) {
    args[len] = arguments[len];
  }

  return dsbridgeSync.apply(void 0, ['lbGetSystemInfo'].concat(args));
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3364
 * @description lbGetToken
  */


var lbGetToken$1 = function lbGetToken$1() {
  var args = [],
      len = arguments.length;

  while (len--) {
    args[len] = arguments[len];
  }

  return dsbridgeSync.apply(void 0, ['lbGetToken'].concat(args));
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3365
 * @description lbOpenWebview
 * @param {string} url default=未填写    描述：网址 url
  */


var lbOpenWebview = function lbOpenWebview(ref) {
  if (ref === void 0) ref = {};
  var url = ref.url;
  return dsbridgeSync('lbOpenWebview', {
    url: url
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3366
 * @description lbCheckAppUpdate
  */


var lbCheckAppUpdate = function lbCheckAppUpdate() {
  var args = [],
      len = arguments.length;

  while (len--) {
    args[len] = arguments[len];
  }

  return dsbridgeSync.apply(void 0, ['lbCheckAppUpdate'].concat(args));
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3367
 * @description lbCheckUpdateStatus
 * @param {boolean} needUpdateLink default=未填写    描述：默认false，true:如有新版本弹窗提示
  */


var lbCheckUpdateStatus = function lbCheckUpdateStatus(ref) {
  if (ref === void 0) ref = {};
  var needUpdateLink = ref.needUpdateLink;
  return dsbridgeSync('lbCheckUpdateStatus', {
    needUpdateLink: needUpdateLink
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3368
 * @description lbDebugInfo
 * @param {object} any default=未填写    描述：debug 信息
  */


var lbDebugInfo = function lbDebugInfo(ref) {
  if (ref === void 0) ref = {};
  var any = ref.any;
  return dsbridgeSync('lbDebugInfo', {
    any: any
  });
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3657
 * @description lbGetSupportList
  */


var lbGetSupportList = function lbGetSupportList() {
  var args = [],
      len = arguments.length;

  while (len--) {
    args[len] = arguments[len];
  }

  return dsbridgeSync.apply(void 0, ['lbGetSupportList'].concat(args));
};
/**
 * @docsUrl https://yapi.dev.longbridge-inc.com/project/53/interface/api/3816
 * @description lbOpenBrowser
 * @param {string} url default=未填写    描述：网址 url
  */


var lbOpenBrowser = function lbOpenBrowser(ref) {
  if (ref === void 0) ref = {};
  var url = ref.url;
  return dsbridgeSync('lbOpenBrowser', {
    url: url
  });
};

export { dsbridge, dsbridgeSync, hasNativeMethod, lbAddArticle, lbAddBankCard, lbAddCalendar, lbAlert, lbBIEventRecord, lbCaptureFinish, lbCaptureStart, lbCheckAppUpdate, lbCheckSupportPath, lbCheckTradeToken, lbCheckUpdateStatus, lbClearStorage, lbCloseWebView, lbConfig, lbConfigContainer, lbConfigNativeBar, lbCourseSubscribeStateUpdate, lbDebugInfo, lbDeleteCalendar, lbDownloadFile, lbEDAAAuth, lbEditor, lbEnableBackGesture, lbEventRecord, lbFollowStock, lbFollowUser, lbGetAppNotificationConfig, lbGetCapitalAccountInfo, lbGetClipboardData, lbGetFeatureFlags, lbGetFileList, lbGetFortune, lbGetImage, lbGetLocation, lbGetMarkets, lbGetNativePage, lbGetNetworkType, lbGetNewsReadStatus, lbGetPhotos, lbGetSignature, lbGetStorage, lbGetStorageInfo, lbGetSupportList, lbGetSystemInfo, lbGetToken$1 as lbGetToken, lbGetUserInfo, lbGetUserMarkets, lbHideKeyboard, lbHideLoading, lbHideToast, lbMmfRiskAssessment, lbOpenBrowser, lbOpenFile, lbOpenPDF, lbOpenWebview, lbPay, lbPreviewImage, lbQueryCalendar, lbRefresh, lbRemoveFile, lbRemoveStorage, lbRequest, lbRiskResult, lbSaveImage, lbScanCode, lbSelectCircle, lbSetClipboardData, lbSetNativeBar, lbSetNativeBarTab, lbSetNavigationLoading, lbSetNewsRead, lbSetStorage, lbSetTools, lbShowActionSheet, lbShowInvitationPoster, lbShowLoading, lbShowLongInvitationPoster, lbShowNewsDetailSettingPanel, lbShowSelectCapitalAccountDialog, lbShowShare, lbShowSharedHolding, lbShowSharedUrl, lbShowStockCardView, lbShowToast, lbStateUpdated, lbSubscribeData, lbSubscribeWS, lbSwitchReadMode, lbTopicFocus, lbTranslateDialog, lbTranslateHtml, lbUnsubscribeData, lbUnsubscribeWS, lbUploadFile, lbUploadProgress, lbUploadVideo, lbVibrate, lbWebViewHeight, openUrlPage };